import { Component, OnInit } from '@angular/core';
import { ConfigureService } from '@app/configure/services/configure.service';
import { Dealer } from '@app/core/models/dealer.model';
import { FinanceQuote } from '@app/core/models/finance-quote.model';
import { ModalService } from '@app/core/services/modal.service';
import { ScriptLoaderService } from '@app/core/services/script-loader.service';
import { SessionService } from '@app/core/services/session.service';
import { ToastService } from '@app/core/services/toast.service';
import { FinanceManagerService } from '@app/finance-manager/services/finance-manager.service';
import { Subject } from 'rxjs';

@Component({
	selector: 'cng-finance-form-modal',
	templateUrl: './finance-form.component.html',
	styleUrls: ['./finance-form.component.less'],
})
export class ConfigureFinanceFormModalComponent implements OnInit {
	dealer: Dealer = this.session_service.getDealer();
	enquiry_hash: string;
	quote: FinanceQuote;
	loading: boolean = true;

	private destroyed$: Subject<boolean> = new Subject<boolean>();

	constructor(
		private script_loader_service: ScriptLoaderService,
		private modal_service: ModalService,
		private toast_service: ToastService,
		private configure_service: ConfigureService,
		private session_service: SessionService
	) {
		this.constructModal();
	}

	constructModal() {
		this.enquiry_hash = this.configure_service.configure_data.meta.enquiry_hash;
		this.quote = this.modal_service.data.quote;

		this.modal_service.setConfig({
			name: 'finance_application_modal',
			title: 'Finance Application',
			size: 'sm',
		});
		this.configure_service.track('modal.open', { modal: 'engage-finance-application' }).subscribe();
	}

	ngOnInit(): void {
		// Load the script, set preferred finance, then load the form
		this.configure_service.setPreferredFinanceFacilityType(this.quote.facility_type).subscribe(() => {
			if ([3, 8].includes(this.quote.finance_provider_id)) {
				Promise.all([this.script_loader_service.load({ name: 'click_proposal_form' })]).then((response) => {
					(<any>window).click.proposalForm.main({
						pluginContentDivId: 'external_form',
						data: {
							enquiryHash: this.enquiry_hash,
							quoteId: this.quote.enq_finance_quotes_id,
							showHeader: false,
							quote: {
								cashDeposit: this.quote.total_deposit,
								facilityType: this.quote.facility_type,
								term: this.quote.term,
								quoteRef: this.quote.quote_UID,
								annualMileage: this.quote.annual_mileage,
							},
						},
						onDomainEvent: (event, data) => this.onDomainEvent(event, data),
						onUserEvent: (event, data) => this.onUserEvent(event, data),
					});
				});
			} else {
				Promise.all([
					this.script_loader_service.load({ name: 'codeweavers_ecommerce_form', params: {
						ApiKey: this.dealer.finance_api_key
					} })
				]).then((response) => {
					(<any>window).codeweavers.ecommerce.apply.main({
						pluginContentDivId: 'external_form',
						quoteReference: this.quote.quote_UID,
					});

					setTimeout(() => {
						this.loading = false;
					}, 2500);
				});
			}
		});
	}

	onDomainEvent(event, data) {
		const checkSuccess = [3, 8].includes(this.quote.finance_provider_id);

		if (event === 'plugin.loaded' && data === true) {
			this.loading = false;
		}

		if (event === 'proposal.successful-submission' && ((checkSuccess && data.success === true) || (!checkSuccess && data === true))) {
			this.modal_service.close().then(() => {
				this.toast_service.success('Your application was submitted');
				this.configure_service.track('engage.applicationSubmittedSuccess', { success: true }).subscribe();

				const route = this.configure_service.isStepEnabled('delivery_options') ? 'delivery_options' : 'reserve';
				this.configure_service.navigateToStep(route);
			});
		}

		if (event === 'proposal.successful-submission' && ((checkSuccess && data.success === false) || (!checkSuccess && data === false))) {
			if (data.errors) {
				this.toast_service.error('A validation error occurred, please check your information and try again');
			} else {
				this.toast_service.error('Sorry, there was an error. Please contact us.');
				this.configure_service.track('engage.applicationSubmittedFail', { success: false }).subscribe();
			}

			if (this.quote.finance_provider_id === 2) {
				this.loading = false;
			}
		}
	}

	onUserEvent(event, data) {
		if (event === 'proposal.submitted' && data === true) {
			this.loading = true;
		}
	}

	ngOnDestroy(): void {
		this.destroyed$.next(true);
	}
}
